import FieldAge from "../../../../generic/datetime/age/age"
import FieldConfig from "../../../../proto/field-config"

export default class FieldTaskAge extends FieldAge {

    constructor(config:FieldConfig) {
        super(config)
    }
}